export default __webpack_public_path__ + "static/4tellAI_home-84c96bc3521a4f4f8bfa5b39e6c86f34.png";